import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-operacao-financeira-detalhar',
  templateUrl: './operacao-financeira-detalhar.component.html',
  styleUrls: ['./operacao-financeira-detalhar.component.scss']
})
export class OperacaoFinanceiraDetalharComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  id?: number;
  operacao?: Operacao;
  loading: boolean = true;

  constructor(private activatedRouter: ActivatedRoute,
    private operacaoFinanceiraService: OperacaoFinanceiraService,
    erroService: ErroService,
    storageService: UtilStorageService) { super(erroService, storageService) }

  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_OPERACAO_FINANCEIRA');
    this.carregarIdOperacao();
    if (this.permissaoDetalhar) {
      this.carregarOperacaoPorId();
    }
  }

  carregarOperacaoPorId() {
    this.operacaoFinanceiraService.buscarPorId(this.id).subscribe({
      next: (data: Operacao) => {
        this.operacao = data;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    });
  }


  carregarIdOperacao() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

}
